import React from 'react';
import AdminDashboard from 'screens/admin/AdminDashboard';
import UserRoute from 'components/Routes/UserRoute';

const routes = [
  <UserRoute key="admin_dashboard" path="/admin/dashboard"><AdminDashboard/></UserRoute>
];

export default routes;
